export async function getSchemes(tenant) {
  for (var i = 1; i <= 5; i++) {
    try {
      const res = await fetch(process.env.VUE_APP_PUBLIC_API_URL + "/schemes/" + tenant, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) {
        console.log("request failed");
        if (i === 5) {
          return {};
        }
      } else {
        return res.json();
      }
    } catch (err) {
      console.log(err);
      if (i === 5) {
        return null;
      }
    }
  }
}

export async function getVoucher(voucherId) {
  for (var i = 1; i <= 5; i++) {
    try {
      const res = await fetch(process.env.VUE_APP_PUBLIC_API_URL + "/voucher/" + voucherId, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) {
        console.log("request failed");
        if (i === 5) {
          return {};
        }
      } else {
        return res.json();
      }
    } catch (err) {
      console.log(err);
      if (i === 5) {
        return {};
      }
    }
  }
}

export async function getTimeslots(api, provider, cert, examId, nd, dateStart, dateEnd, examDuration, trainer) {
  let url = `${api}/scheduler?cert=${cert}&provider=${provider}`;
  if (nd) {
    url += "&nd=true";
  }
  if (dateStart) {
    url += `&dateStart=${dateStart}`;
  }
  if (dateEnd) {
    url += `&dateEnd=${dateEnd}`;
  }
  if (examId) {
    url += `&examId=${examId}`;
  }
  if (examDuration) {
    url += `&duration=${examDuration}`;
  }
  if (trainer) {
    url += `&trainer=${trainer}`;
  }

  for (var i = 1; i <= 5; i++) {
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) {
        console.log("request failed");
        if (i === 5) {
          return {};
        }
      }
      return res.json();
    } catch (err) {
      console.log(err);
      if (i === 5) {
        return null;
      }
    }
  }
}

export async function getDates(tenant) {
  for (var i = 1; i <= 5; i++) {
    try {
      const res = await fetch(process.env.VUE_APP_PUBLIC_API_URL + "/dates/" + tenant, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) {
        console.log("request failed");
        if (i === 5) {
          return {};
        }
      }
      return res.json();
    } catch (err) {
      console.log(err);
      if (i === 5) {
        return null;
      }
    }
  }
}

export async function getPersonalData(id) {
  for (var i = 1; i <= 5; i++) {
    try {
      const res = await fetch(process.env.VUE_APP_CMP_API + "/public/application/" + id, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) {
        console.log("request failed");
        if (i === 5) {
          return {};
        }
      } else {
        return res.json();
      }
    } catch (err) {
      console.log(err);
      if (i === 5) {
        return {};
      }
    }
  }
}

export async function getTrainerSettings(api, trainer) {
  for (var i = 1; i <= 5; i++) {
    try {
      const res = await fetch(`${api}/trainer/${trainer}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) {
        console.log("request failed");
        if (i === 5) {
          return {};
        }
      } else {
        return await res.json();
      }
    } catch (err) {
      console.log(err);
      if (i === 5) {
        return null;
      }
    }
  }
}
